import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";

interface Props {
    isShown: boolean
    refNos: string[]
    onConfirm: () => void
    onClose: () => void
}

/**
 * E-irsaliyeyi GİB'e göndermeden önce onay. GİB'e giden irsaliye geri alınamaz;
 * kullanıcı bunu işaretleyerek onaylamadan "Gönder" açılmaz.
 */
const GibConfirmModal = ({ isShown, refNos, onConfirm, onClose }: Props) => {
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        if (isShown)
            setAccepted(false);
    }, [isShown])

    const shown = refNos.slice(0, 10);

    return (
        <Modal
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-600px'
            show={isShown}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>E-İrsaliye GİB'e gönderilecek</h2>
            </div>

            <div className='modal-body'>
                <div className='alert alert-danger d-flex align-items-start p-4 mb-5'>
                    <i className='fa fa-exclamation-triangle text-danger fs-2 me-3 mt-1'></i>
                    <div>
                        <div className='fw-bold mb-1'>Bu işlem geri alınamaz.</div>
                        <div>GİB'e gönderilen irsaliye resmîleşir; iptal edilemez, yalnız ters işlemle düzeltilebilir. Göndermeden önce taslakları Uyumsoft portalında kontrol ettiğinizden emin olun.</div>
                    </div>
                </div>

                <div className='fs-6 mb-2'><b>{refNos.length}</b> kayıt gönderilecek{refNos.length > 1 ? ' (her biri ayrı irsaliye, arka planda sırayla)' : ''}:</div>
                <div className='text-gray-700 fs-7 mb-5'>
                    {shown.join(', ')}{refNos.length > shown.length ? ` ve ${refNos.length - shown.length} kayıt daha` : ''}
                </div>

                <label className='form-check form-check-custom form-check-solid'>
                    <input id='gib-confirm-accept' className='form-check-input' type='checkbox' checked={accepted} onChange={() => setAccepted(!accepted)} />
                    <span className='form-check-label fw-bold text-gray-800'>GİB'e gönderimin geri alınamayacağını anlıyorum.</span>
                </label>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">
                    Vazgeç
                </button>
                <button onClick={onConfirm} disabled={!accepted} type="button" className="btn btn-danger">
                    GİB'e Gönder
                </button>
            </div>
        </Modal>
    )
}

export default GibConfirmModal;
